import React from 'react';
import { FormattedNumber } from 'react-intl';

import { Table } from 'antd';

import { useLoadItems } from 'v2/hooks/useLoadItems';

import { useFiscalDocuments } from '../../context';

type ItemRow = {
  id: number;
  description: string;
  qty: number;
  value?: number;
};

const Items: React.FC = () => {
  const { selectedData } = useFiscalDocuments();
  const { items, isLoading } = useLoadItems(selectedData.id);

  return (
    <div className='overflow-x-auto'>
      <Table<ItemRow>
        loading={isLoading}
        columns={[
          {
            title: 'Detalhes',
            dataIndex: 'description',
            key: 'description'
          },
          {
            title: 'Qtd',
            dataIndex: 'qty',
            key: 'qty',
            width: 80
          },
          {
            title: 'Total',
            dataIndex: 'value',
            key: 'value',
            width: 120,
            align: 'right',
            render: (_, item) => <FormattedNumber value={item.value || 0} format='BRL' />
          }
        ]}
        dataSource={items as ItemRow[]}
        rowKey='id'
        pagination={false}
        size='small'
        locale={{ emptyText: 'Nenhum registro encontrado.' }}
        scroll={{ x: 345 }}
      />
    </div>
  );
};

export default Items;
